// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qWLN","footer":"styles_footer__2j3GT"};